module.exports = __webpack_public_path__ + "img/jkfw.5773e7dd.png";